import { useRef as c, useEffect as u } from "react";
function h(n) {
  const p = c([]), o = p.current.map((e) => e.id), d = n.map((e) => e.id);
  if (u(() => {
    p.current = n;
  }, [n]), o.length === 0)
    return { prepended: [], appended: n };
  if (d.length === 0)
    return { prepended: [], appended: [] };
  const i = new Set(o);
  let r = -1;
  for (let e = 0; e < d.length; e++)
    if (i.has(d[e])) {
      r = e;
      break;
    }
  if (r === -1)
    return { prepended: [], appended: n };
  let t = -1;
  for (let e = d.length - 1; e >= 0; e--)
    if (i.has(d[e])) {
      t = e;
      break;
    }
  if (t === -1)
    return { prepended: n, appended: [] };
  const f = n.slice(0, r), l = n.slice(t + 1);
  return { prepended: f, appended: l };
}
export {
  h as useCompareMessages
};
